import {request,newVue,requestMsg} from "./request";
export {newVue}

let role = null;

export function setRole(roleNew) {
  role = roleNew
}

export function getRole() {
  return role;
}

export function getAdminBySearch(roleName,pageNum,pageSize) {
  return request({
    url: '/admin/getAdminBySearch',
    params: {
      roleName: roleName,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function updateAdmin(admin) {
  console.log(admin);
  return requestMsg({
    url: '/admin/updateAdmin',
    data: JSON.stringify(admin),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function updateRole(role) {
  return requestMsg({
    url: '/admin/updateRole',
    data: JSON.stringify(role),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function getAdminById(id) {
  return requestMsg({
    url: '/admin/getAdminById',
    params: {
      id: id,
    }
  })
}

export function adminLogin(user) {
  return request({
    url: '/login/adminLogin',
    data: JSON.stringify(user),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function delByAdminId(id) {
  return requestMsg({
    url: '/admin/delByAdminId',
    params: {
      id: id,
    }
  })
}

export function getRoleAll(id) {
  return requestMsg({
    url: '/admin/getRoleAll',
    params: {
      id: id,
    }
  })
}
